import Link from './Link';

export { type LinkProps } from './Link';
export default Link;
